import fetch from 'isomorphic-fetch';
import _ from 'lodash';
import { spanishResouceData } from '../../../constants/medicareData.js';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { ONLY_NUMBER_REGEX } from '../../../constants/defaults.js';

const ssrBff = axios.create({ baseURL: `http://localhost:8080/api` });

ssrBff.interceptors.request.use(request => {
  const headers = {
    ...request.headers
  };
  headers['x-request-id'] = uuidv4();
  request.headers = headers;
  console.log(
    `[SSR BFF Request] [${request.headers['x-request-id']}] ${request.method} ${request.url} calling...`
  );
  return request;
});

ssrBff.interceptors.response.use(response => {
  console.log(
    `[SSR BFF Response] [${response.headers['x-request-id']}] [${response.status}] ${response.request.method} ${response.request.path} response`
  );
  response.data.requestId = response.headers['x-request-id'];
  return response;
});

const getQueryForLocation = (cookies, url) => {
  if (cookies && ONLY_NUMBER_REGEX.test(cookies.zipCode))
    return `&zipCode=${cookies.zipCode}`;
  else if (cookies && cookies.locationLat && cookies.locationLon)
    return `&latitude=${cookies.locationLat}&longitude=${cookies.locationLon}`;
  else return url;
};

export async function fetchDrugDetails(drugname, cookies, url) {
  const searchParams = _.queryStringToJSON(url);
  let apiUrl = `/drug-detail/${drugname}`;
  if (searchParams && searchParams.preview == 'true') apiUrl += `?preview=true`;
  else apiUrl += `?preview=false`;
  apiUrl += getQueryForLocation(cookies, apiUrl);
  const encodedURI = encodeURI(apiUrl);
  try {
    return (await ssrBff.get(encodedURI)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

// export function fetchHomeBlog(lang) {
//   if (lang == 'es') {
//     return;
//   } else {
//     return fetch(`${config.BLOG_HOST}/blog/tag/seasonal/?json=1&count=4`)
//       .then(data => data.json())
//       .then(repos => repos)
//       .catch(error => {
//         console.warn(error);
//         return null;
//       });
//   }
// }

// TODO verify usage (1)
export async function fetchDrugContents(drugname, cookies, urls, lang) {
  const searchParams = _.queryStringToJSON(urls);
  let url = `/prescription/${drugname}?tenantId=0&locale=${lang}`;
  if (cookies && cookies.sessionId) url += `&sessionId=${cookies.sessionId}`;
  url += getQueryForLocation(cookies, url);
  if (cookies && !_.isEmpty(cookies.isLoggedIn)) {
    url += `&isLoggedIn=${true}`;
  }
  if (cookies && !_.isEmpty(cookies.drugData))
    url += `&drugData=${cookies.drugData}`;
  if (searchParams && searchParams.preview == 'true') url += `&preview=true`;
  const encodedURI = encodeURI(url);
  console.log('BFF SSR SERVICE encodedURI: ' + encodedURI);
  try {
    return (await ssrBff.get(encodedURI)).data;
  } catch (error) {
    console.log('error while BFF get drug Data', error?.response?.data);
    return error?.response?.data;
  }
}

export async function fetchDrugContentsDetails(drugname, cookies, urls, lang) {
  const searchParams = _.queryStringToJSON(urls);
  let url = `/new-prescription/${drugname}?tenantId=0&locale=${lang}`;
  if (cookies && cookies.sessionId) url += `&sessionId=${cookies.sessionId}`;
  url += getQueryForLocation(cookies, url);
  if (cookies && !_.isEmpty(cookies.drugData))
    url += `&drugData=${cookies.drugData}`;
  if (searchParams && searchParams.preview == 'true') url += `&preview=true`;
  const encodedURI = encodeURI(url);
  console.log('BFF SSR SERVICE encodedURI: ' + encodedURI);
  try {
    return (await ssrBff.get(encodedURI)).data;
  } catch (error) {
    console.log('error while BFF get drug Data', error?.response?.data);
    return error?.response?.data;
  }
}

// TODO verify usage
export async function fetchConditionsByTerms(terms, url) {
  const slugType = terms.split('-').reverse()[0];
  const isSymptomsCauses = slugType === 'causes' || slugType === 'symptoms';
  if (isSymptomsCauses) {
    const fetchData = await fetchSymptomCausesDetailData(terms, url);
    return { ...fetchData, slugType, isSymptomsCauses };
  } else {
    let bodyData = {
      conditionNameSlug: terms
    };
    const searchParams = _.queryStringToJSON(url);
    if (searchParams && searchParams.preview == 'true') bodyData.preview = true;
    try {
      const fetchData = (await ssrBff.post('/conditions/by-name', bodyData))
        .data;
      return { ...fetchData, slugType: 'treatments' };
    } catch (err) {
      console.warn(err);
      return err?.response?.data;
    }
  }
}

export async function fetchQuestionsByTerms(terms, url) {
  const fetchData = await fetchSymptomCausesDetailData(terms, url);
  return { ...fetchData, slugType: 'directory', isSymptomsCauses: true };
}

// TODO verify usage
export async function fetchConditions() {
  try {
    return (await ssrBff.get('/conditions')).data;
  } catch (error) {
    console.warn(error);
    return error?.response?.data;
  }
}

// TODO verify usage
export async function fetchPriceHistory(url) {
  try {
    return (await ssrBff.get(`/prescription/priceHistory${url}`)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

// TODO verify usage
export async function getFaqs(lng) {
  try {
    return (await ssrBff.get(`/faqs?locale=${lng}`)).data;
  } catch (error) {
    console.warn(error);
    return error?.response?.data;
  }
}
// TODO verify usage
export async function fetchTrendingDrugs(lng) {
  try {
    return (
      await ssrBff.get(
        `/cms/getTrendingDrugs?locale=${lng === 'es' ? 'es-US' : 'en-US'}`
      )
    ).data;
  } catch (error) {
    console.warn(error);
    return error?.response?.data;
  }
}

// TODO verify usage
export async function fetchPrescriptionCardData(slug, url, lng) {
  const searchParams = _.queryStringToJSON(url);
  let pageSlug = lng === 'es' ? slug.replace('/es/', '') : slug.substring(1);
  pageSlug =
    pageSlug == 'doctors' || pageSlug == 'pharmacists'
      ? 'prescription-discount-card'
      : pageSlug;
  let bodyData = {
    slug: decodeURI(pageSlug),
    locale: lng === 'es' ? 'es-US' : 'en-US'
  };
  // console.log(JSON.stringify(bodyData));
  if (searchParams && searchParams.preview == 'true') bodyData.preview = true;

  try {
    return (await ssrBff.post('/discount-card', bodyData)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

// TODO verify usage
export async function fetchBrowsePrescriptionData(slug, url, lng) {
  const searchParams = _.queryStringToJSON(url);
  let pageSlug =
    lng === 'es'
      ? decodeURI(slug.replace('/es/', ''))
      : decodeURI(slug.substring(1));
  let locale = lng === 'es' ? 'es-US' : 'en-US';

  const params = {
    locale: locale
  };
  if (searchParams && searchParams.preview == 'true') {
    params.preview = 'true';
  }

  try {
    return (
      await ssrBff.get(`/${pageSlug}?${new URLSearchParams(params).toString()}`)
    ).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

// TODO: verify usage
export async function fetchDrugDosageDetails(drugname, cookies, url, lang) {
  const searchParams = _.queryStringToJSON(url);
  let bodyData = {
    seoName: `${drugname}`,
    locale: lang === 'es' ? 'es-US' : 'en-US',
    preview: searchParams && searchParams.preview == 'true'
  };
  try {
    return (await ssrBff.post('/cms/drug-dosages', bodyData)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

// TODO verify usage
export function fetchDrugSideEffectDetails(drugname, cookies, url, lang) {
  const searchParams = _.queryStringToJSON(url);
  let bodyData = {
    seoName: `${drugname}`,
    locale: lang === 'es' ? 'es-US' : 'en-US',
    preview: searchParams && searchParams.preview == 'true'
  };
  return fetch(`http://localhost:8080/api/drug-side-effects`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyData)
  })
    .then(data => data.json())
    .then(repos => repos)
    .catch(error => {
      console.warn(error);
      return error?.response?.data;
    });
}

export async function fetchNearMe(url) {
  const searchParams = _.queryStringToJSON(url);
  let apiUrl = `http://localhost:8080/api/pharma-nearMe`;
  if (searchParams && searchParams.preview == 'true') apiUrl += `?preview=true`;
  const encodedURI = encodeURI(apiUrl);

  try {
    return (await ssrBff.get(encodedURI)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

// TODO verify usage
export async function fetchCity(cityState, url) {
  const searchParams = _.queryStringToJSON(url);
  let apiUrl = `/pharma-city?cityState=` + cityState;
  if (searchParams && searchParams.preview == 'true') apiUrl += `&preview=true`;
  const encodedURI = encodeURI(apiUrl);
  try {
    return (await ssrBff.get(encodedURI)).data;
  } catch (err) {
    console.warn(err);
  }
  return null;
}

// TODO verify usage
export async function fetchState(state, url) {
  const searchParams = _.queryStringToJSON(url);
  let apiUrl = '/pharma-state?stateShort=' + state;
  if (searchParams && searchParams.preview == 'true') apiUrl += `&preview=true`;
  const encodedURI = encodeURI(apiUrl);

  try {
    return (await ssrBff.get(encodedURI)).data;
  } catch (err) {
    console.warn(err);
  }
  return null;
}

// TODO verify usage
export async function fetchPharmaciesBrand(brand, url) {
  const searchParams = _.queryStringToJSON(url);
  let apiUrl = '/pharma-brands-nearMe?brand=' + brand;
  if (searchParams && searchParams.preview == 'true') apiUrl += `&preview=true`;
  const encodedURI = encodeURI(apiUrl);

  try {
    return (await ssrBff.get(encodedURI)).data;
  } catch (err) {
    console.warn(err);
  }
  return null;
}

// TODO verify usage
export async function fetchPharmaciesBrandCity(cityBrand, url) {
  const searchParams = _.queryStringToJSON(url);
  let apiUrl = '/pharma-brand-city?cityBrand=' + cityBrand;
  if (searchParams && searchParams.preview == 'true') apiUrl += `&preview=true`;
  const encodedURI = encodeURI(apiUrl);

  try {
    return (await ssrBff.get(encodedURI)).data;
  } catch (err) {
    console.warn(err);
  }
  return null;
}

// TODO verify usage
export async function fetchStoreDetails(path, url) {
  const searchParams = _.queryStringToJSON(url);
  let npiArray = path.split('-');
  let urlPath = path.split('/')[2];
  let apiUrl = '/pharma-brandDetails?npi=' + npiArray[npiArray.length - 1];
  apiUrl += `&url=` + urlPath;
  if (searchParams && searchParams.preview == 'true') apiUrl += `&preview=true`;
  const encodedURI = encodeURI(apiUrl);

  try {
    return (await ssrBff.get(encodedURI)).data;
  } catch (err) {
    console.warn(err);
  }
  return null;
}

// TODO verify usage
export async function fetchArticlesData(slug, cookies, url, lang) {
  const searchParams = _.queryStringToJSON(url);
  let bodyData = {
    slug: `${slug}`,
    locale: lang === 'es' ? 'es-US' : 'en-US',
    preview: searchParams && searchParams.preview == 'true'
  };
  try {
    return (await ssrBff.post('/cms/spanish/article', bodyData)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

export async function fetchPressCenterData(slug, cookies, url, lang) {
  const searchParams = _.queryStringToJSON(url);

  let locale = lang === 'es' ? 'es-US' : 'en-US';
  let query = `?locale=${locale}`;
  if (searchParams && searchParams.preview == 'true') {
    query += `&preview=true`;
  }

  try {
    return (await ssrBff.get(`/cms/press-center-homepage${query}`)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

// eslint-disable-next-line no-unused-vars
export async function fetchPressReleaseArticleData(slug, cookies, url, lang) {
  const searchParams = _.queryStringToJSON(url);
  let bodyData = {
    slug: `${slug}`,
    preview: searchParams && searchParams.preview == 'true'
  };
  try {
    return (await ssrBff.post('/cms/press-center-article', bodyData)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

export async function fetchMedicareData(slug, cookies, url, lang) {
  try {
    return (await ssrBff.get(`/cms/getMedicareData?lang=${lang}`))?.data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

export async function fetchResourceData(name = '', path, cookies, url) {
  const searchParams = _.queryStringToJSON(url);
  try {
    return (
      await ssrBff.post(`/cms/resources/landing-page`, {
        name: name,
        preview: searchParams && searchParams.preview === 'true' ? true : false
      })
    ).data;
  } catch (err) {
    console.warn(err);
    return spanishResouceData;
  }
}

export async function fetchAllColletctionPages(slug, cookies, url) {
  try {
    const searchParams = _.queryStringToJSON(url);
    let bodyData = {
      name: `Resources`,
      preview: searchParams && searchParams.preview == 'true'
    };
    return (await ssrBff.post('/cms/getAllCollectionPages', bodyData)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

export async function fetchDrugColletctionPage(slug, cookies, url) {
  try {
    const searchParams = _.queryStringToJSON(url);
    let bodyData = {
      urlSlug: slug,
      preview: searchParams && searchParams.preview == 'true'
    };
    return (await ssrBff.post('/cms/getDrugCollectionPage', bodyData)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

export async function fetchDrugClass() {
  try {
    return (await ssrBff.get('/drug-classes')).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

// eslint-disable-next-line no-unused-vars
export async function fetchDrugClassDetailData(slug, cookies, url, lang) {
  try {
    const searchParams = _.queryStringToJSON(url);
    let bodyData = {
      slug: `${slug}`,
      preview: searchParams && searchParams.preview == 'true'
    };
    return (await ssrBff.post('/cms/drug-class-page', bodyData)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

export async function fetchSymptomCausesDetailData(slug, url) {
  const searchParams = _.queryStringToJSON(url);
  let bodyData = {
    slug: `${slug}`,
    preview: searchParams && searchParams.preview == 'true'
  };
  try {
    return (await ssrBff.post('/conditions/symptom-cause', bodyData)).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

// export async function fetchSymptomsCausesByTerms(terms, type) {
//   let bodyData = {
//     query: terms,
//     conditionType: type
//   };
//   try {
//     return (await ssrBff.post('/conditions/search-symptom-cause', bodyData))
//       .data;
//   } catch (err) {
//     console.warn(err);
//   }
//   return null;
// }

export async function fetchCauses() {
  try {
    return (await ssrBff.get('/conditions/causes')).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

export async function fetchSymptoms() {
  try {
    return (await ssrBff.get('/conditions/symptoms')).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

export async function fetchContentfulStaticData(slug, url, lang) {
  const searchParams = _.queryStringToJSON(url);
  try {
    return (
      await ssrBff.post('cms/getContentfulStaticData', {
        slug: `${slug}`,
        locale: lang === 'es' ? 'es-US' : 'en-US',
        platform: 'WEB',
        preview: searchParams && searchParams.preview == 'true'
      })
    ).data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}
